import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-h1-heading',
  imports: [CommonModule],
  template: `
    <div [ngClass]="classContainer + ' p-4'">
      <div class="flex justify-between items-center w-full flex-wrap gap-4">
        <h1 class="text-2xl font-light font-inter text-secondary" [ngClass]="class">
          {{ heading }}
        </h1>
        <div class="flex items-center gap-2 flex-wrap">
          <ng-content select="[broker-selector]"></ng-content>
          <ng-content></ng-content>
        </div>
      </div>
    </div>
  `,
  standalone: true,
})
export class H1Heading {
  @Input() heading: string = '';
  @Input() class: string = '';
  @Input() classContainer: string = '';
}
